export default __webpack_public_path__ + "static/media/circulardots.34b66bcb.svg";